<template>
    <div class="views-content--supplier">
        <banner-image :data="data.hero"></banner-image>
        
        <locations :class="addedClassZero" :data="data.locations" :projectTypes="data.projectTypes" :serviceTypes="data.serviceTypes"  :totalSuppliers="data.totalSuppliers" />

        <!-- elements -->
        <div v-for="(element, index) in data.elements" :key="element.id">
            <component 
                :class="elementClass(element.vueName, index)" 
                :is="element.vueName" 
                :data="alteredElements[index]"
                @addNeighbourClass="addNeighbourClassHandle"
            />
        </div>
    </div>
</template>

<script>
    import viewsElementClasses from '../mixins/viewsElementClasses';
    import { BannerImage, Locations, Cta } from "../components";
    // elements
    import { ElementAccordion, ElementBackgroundImage, ElementContent, ElementCTA, ElementColours,ElementImage, ElementLinks, ElementImages, ElementProducts, ElementSplitSlider, ElementTiles, ElementVideo, ElementPercentage} from "../components";

    export default {
        name: "v-supplier",
        mixins: [viewsElementClasses],
        components: {
            BannerImage,
            Locations,
            Cta,
            // Elements
            ElementAccordion,
            ElementBackgroundImage,
            ElementColours,
            ElementContent,
            ElementCTA,
            ElementLinks,
            ElementImages,
            ElementImage,
            ElementProducts,
            ElementSplitSlider,
            ElementTiles,
            ElementVideo,
            ElementPercentage
        },
        props: {
            data: {
                type: Object
            }
        }
    };
</script>
